import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'
const vue = new Vue()

const state = {
  merchantList: {}, // 查询列表
  merchantInfo: {}, // 商户信息
  addMerchantStatus: false,
  merchantMark: 0,
  merchantData: '', // 商户信息
  merchantManageAdd: 0,
  merchantManageWareAdd: 0,
  menuList: {}, // 菜单列表
  menuPermissionList: {}, // 菜单权限列表
  miniProgramData: {}, // 商户小程序设置数据
  appletLogList: {}, // 小程序上传日志
  combolist: [], // 套餐选项
  savecombolist: 0, // 套餐保存
  savesupplier: 0,
  deletecombo: 0,
  querycomboinifo: {
    menu: {
      leftMenuIds: [],
      rightMenuIds: []
    }
  }
}
const actions = {
  [types.FINDALLTENANT] (context, params) { // 获取商户列表
    http.fetch('/api/tenant/findALLTenant', params).then(data => {
      context.commit(types.FINDALLTENANT, data)
    })
  },
  [types.ADDTENANT] (context, params) { // 新增 or 编辑 保存商户
    http.fetch('/api/tenant/addTenant', params).then(data => {
      context.commit(types.ADDTENANT, data)
    })
  },
  [types.TENANTPWD] (context, params) { // 重置密码
    http.fetch('/api/tenant/tenantPwd', params).then(data => {
      context.commit(types.TENANTPWD, data)
    })
  },
  [types.WAREHOUSEADD] (context, params) { // 新增仓库
    http.fetch('/api/warehouse/add', params).then(data => {
      context.commit(types.WAREHOUSEADD, data)
    })
  },
  [types.SHOWTENANT] (context, params) { // 通过code查询商户信息
    http.fetch('/api/tenant/showTenant', params).then(data => {
      context.commit(types.SHOWTENANT, data)
    })
  },
  [types.COMBOLIST] (context) { // 套餐下拉
    http.fetch('/api/comboInfo/supplierComboList').then(data => {
      context.commit(types.COMBOLIST, data)
    })
  },
  [types.SAVECOMBOLIST] (context, params) { // 保存商户列表套餐
    http.fetch('/api/tenant/saveCombo', params).then(data => {
      context.commit(types.SAVECOMBOLIST, data)
    })
  },
  [types.QUERYCOMBOINIFO] (context, params) { // 编辑查看商户套餐
    http.fetch('/api/comboInfo/queryComboInfo', params).then(data => {
      context.commit(types.QUERYCOMBOINIFO, data)
    })
  },
  [types.DELETECOMBO] (context, params) { // 删除套餐
    http.fetch('/api/comboInfo/deleteComboInfo', params).then(data => {
      context.commit(types.DELETECOMBO, data)
    })
  },
  [types.SAVESUPPLIERS] (context, params) { // 保存商户套餐
    http.fetch('/api/comboInfo/saveSupplierComboInfo', params, 'application/json').then(data => {
      context.commit(types.SAVESUPPLIERS, data)
    })
  },
  // 获取菜单权限列表
  [types.GETMENUROLETREES] (context, params) {
    http.fetch('/api/menu/getMenuRoleTree', params).then(data => {
      context.commit(types.GETMENUROLETREES, data)
    })
  },
  // 获取该角色的菜单权限
  [types.SELECTMENUBYYCTCODE] (context, params) {
    http.fetch('/api/tenant/selectMenuByYctCode', params).then(data => {
      context.commit(types.SELECTMENUBYYCTCODE, data)
    })
  },
  // 编辑菜单权限
  [types.SETMENUBYYCTCODE] (context, params) {
    http.fetch('/api/tenant/setMenuByYctCode', params, 'application/json').then(data => {
      context.commit(types.SETMENUBYYCTCODE, data)
    })
  },

  // 获取小程序设置
  [types.GETAUTHORIZATIONINFO] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/tenant/getAuthorizationInfo', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取预授权码，返回授权链接(对应原型上的重新绑定按钮)
  [types.GETCOMPONENTURL] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/getComponentUrl', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 同步信息
  [types.SYNCINFO] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/synchronizationInfo', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取代码模板列表
  [types.GETTEMPLATELIST] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/getTemplateList', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 上传代码(批量的)
  [types.COMMIT] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/commit', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取体验二维码
  [types.GETQRCODE] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/getQrcode', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 配置小程序用户隐私保护指引
  [types.SETPRIVACYSETTING] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/setPrivacySetting', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 提交审核
  [types.SUBMITAUDIT] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/submitAudit', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 审核撤回
  [types.UNDOCODEAUDIT] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/unDoCodeAudit', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 查询最新一次提交审核的状态
  [types.GETLATESAUDITSTATUS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/getLatestAuditstatus', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 发布已通过审核的小程序
  [types.RELEASE] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/release', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 小程序版本回退
  [types.REVERTCODERELEASE] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/revertCodeRelease', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取授权小程序列表
  [types.GETYCAUTHORIZATIONAPPLELIST] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/getYcAuthorizationAppletList', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取授权小程序列表
  [types.APPLYPLUGIN] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/applyPlugin', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 设置服务器域名
  [types.MODIFYDOMAIN] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/component/modifyDomain', params).then(data => {
        if (data.success) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 小程序日志
  [types.GETYCAUTHORIZATIONAPPLETLOGPAGE] (context, params) { // 获取商户列表
    http.fetch('/api/component/getYcAuthorizationAppletLogPage', params).then(data => {
      context.commit(types.GETYCAUTHORIZATIONAPPLETLOGPAGE, data)
    })
  }
}
const mutations = {
  [types.FINDALLTENANT] (state, data) {
    state.merchantList = data
  },
  [types.ADDTENANT] (state, data) {
    if (data.code !== 200) return
    state.merchantManageAdd = 1
    state.merchantData = data.obj
  },
  [types.SHOWTENANT] (state, data) {
    if (data.code !== 200) return
    if (data.obj) {
      data.obj.yctRegion = data.obj.yctRegion.split(',')
      state.merchantInfo = data.obj
    } else {
      state.merchantInfo = { yctName: null }
    }
  },
  [types.TENANTPWD] (state, data) {
    if (data.code !== 200) return
    vue.$message({
      showClose: true,
      message: '重置密码成功',
      type: 'success'
    })
  },
  // 获取菜单权限列表
  [types.GETMENUROLETREES] (state, data) {
    state.menuList = data.obj
  },
  // 套餐下拉
  [types.COMBOLIST] (state, data) {
    state.combolist = data.obj
  },
  [types.SAVECOMBOLIST] (state, data) {
    if (data.code !== 200) return
    state.savecombolist = 1
  },
  [types.QUERYCOMBOINIFO] (state, data) {
    state.querycomboinifo.menu = data.obj.menu
  },
  [types.DELETECOMBO] (state, data) {
    if (data.code !== 200) return
    state.deletecombo = 1
  },
  [types.SAVESUPPLIERS] (state, data) {
    if (data.code !== 200) return
    state.savesupplier = 1
  },
  // 获取该角色的菜单权限
  [types.SELECTMENUBYYCTCODE] (state, data) {
    state.menuPermissionList = data.obj
  },
  // 编辑菜单权限
  [types.SETMENUBYYCTCODE] (state, data) {
    if (data.code !== 200) return
    state.merchantMark = 1
    vue.$message({
      showClose: true,
      message: '编辑成功',
      type: 'success'
    })
  },
  [types.WAREHOUSEADD] (state, data) {
    if (data.code !== 200) return
    state.merchantManageWareAdd = 1
    vue.$message({
      showClose: true,
      message: '新增成功',
      type: 'success'
    })
  },
  [types.GETYCAUTHORIZATIONAPPLETLOGPAGE] (state, data) {
    state.appletLogList = data
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/merchantManage/index.js